import axios from 'axios';
import { BASE_URL, PLAYLIST_API_PATH, VIDEO_ASSET_API_PATH } from 'constants/api';
import { ApiService } from 'service/api/apiService';
import { FetchResult } from 'type/apiType';
import {
  FeedValidation,
  FeedValidationDetail,
  PlaylistInterface,
  RecoverResult,
} from '../types/playlistType';

class PlaylistApiService {
  constructor(private apiService: ApiService<PlaylistInterface>) {}

  public async fetch(params?: URLSearchParams): Promise<FetchResult<PlaylistInterface>> {
    return this.apiService.fetch(params);
  }

  public async fetchById(id: number, params?: Record<string, string>): Promise<PlaylistInterface> {
    return this.apiService.fetchById(id, params);
  }

  public async create(playlist: PlaylistInterface): Promise<PlaylistInterface> {
    return await this.apiService.create(playlist);
  }

  public async update(id: number, playlist: PlaylistInterface): Promise<void> {
    await this.apiService.update(id, playlist);
  }

  /** Starts a validation run. 409 when one is already pending or running for the playlist. */
  public async submitValidation(playlistId: number): Promise<FeedValidation> {
    const response = await axios.post(
      `${BASE_URL}${PLAYLIST_API_PATH}${playlistId}/validate-feed/`
    );
    return response.data;
  }

  /** The 20 most recent runs, newest first. */
  public async fetchValidationHistory(playlistId: number): Promise<FeedValidation[]> {
    const response = await axios.get(`${BASE_URL}${PLAYLIST_API_PATH}${playlistId}/validate-feed/`);
    return response.data;
  }

  public async fetchValidationDetail(
    playlistId: number,
    validationId: number
  ): Promise<FeedValidationDetail> {
    const response = await axios.get(
      `${BASE_URL}${PLAYLIST_API_PATH}${playlistId}/validate-feed/${validationId}/`
    );
    return response.data;
  }

  public async recoverVideo(videoId: number): Promise<RecoverResult> {
    const response = await axios.post(`${BASE_URL}${VIDEO_ASSET_API_PATH}${videoId}/recover/`);
    return response.data;
  }
}

export const playlistApiService = new PlaylistApiService(
  new ApiService<PlaylistInterface>(PLAYLIST_API_PATH)
);
